window.addEventListener('DOMContentLoaded', () => {
  const smoothTrigger = document.querySelectorAll('.u-smooth-scroll');

  if (smoothTrigger) {
    smoothTrigger.forEach(trigger => {
      const el = trigger;
      const { target } = el.dataset;
      let targetEl = document.querySelector(target);

      if (target === 'smooth-next-section') {
        const parentSection = trigger.parentNode.parentNode.parentNode;
        const parentSectionSibling = parentSection.nextElementSibling;
        targetEl = parentSectionSibling;
      }

      el.addEventListener('click', () => {
        window.scrollBy({
          left: 0,
          top: targetEl.getBoundingClientRect().top,
          behavior: 'smooth',
        });
      });
    });
  }
});



// WEBPACK FOOTER //
// ./src/scripts/modules/smoothScroll.js